import { PropsWithChildren, createContext } from 'react';

import VerificationMethodSelectionManager from 'modules/EndToEndEncryption/VerificationMethodSelectionManager';
import SasVerificationManager from 'modules/SasVerification/SasVerificationManager';

import useMatrixDeviceVerificationController from './useMatrixDeviceVerificationController';

type MatrixDeviceVerificationContextType = ReturnType<typeof useMatrixDeviceVerificationController>;

const MatrixDeviceVerificationContext = createContext<MatrixDeviceVerificationContextType | null>(null);

export const MatrixDeviceVerificationProvider = ({ children }: PropsWithChildren) => {
  const value = useMatrixDeviceVerificationController();
  return (
    <MatrixDeviceVerificationContext.Provider value={value}>
      <VerificationMethodSelectionManager />
      <SasVerificationManager />
      {children}
    </MatrixDeviceVerificationContext.Provider>
  );
};

export default MatrixDeviceVerificationContext;
